import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const App = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: hidden;
`
const Body = styled.div`
  height: 100%;
  display: flex;
`

class ShopifyAppLayout extends Component {

  render () {
    const { header, subheader, body } = this.props
    return (
      <App>
        {header}
        {subheader}
        <Body>
          {body}
        </Body>
      </App>
    )
  }
}

ShopifyAppLayout.propTypes = {
  header: PropTypes.element,
  subheader: PropTypes.element,
  body: PropTypes.element,
}

export default ShopifyAppLayout



// WEBPACK FOOTER //
// ./src/components/shopifyApp/ShopifyAppLayout.js